import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light: '#F6861E',
      main: '#F6861E',
      dark: '#F6861E',
      contrastText: '#fff'
    },
    secondary: {
      light: '#4ad4d4',
      main: '#4ad4d4',
      dark: '#4ad4d4',
      contrastText: '#000'
    }
  }
});
